var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SearchBox',{attrs:{"labeltxt":_vm.labeltxt,"row":_vm.row}},[_c('v-textarea',{attrs:{"solo":"","value":_vm.value,"label":_vm.placeholder,"disabled":_vm.disabled,"background-color":_vm.bgColor,"rows":_vm.rows,"error-messages":_vm.errorsMsg,"auto-grow":"","maxlength":_vm.max},on:{"input":(value) => _vm.$emit('input', value)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }